module.exports = __webpack_public_path__ + "static/media/pdf.3e89ea5a.svg";